/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Signin_WaitlistInputs */

const en_booking_signin_waitlist = /** @type {(inputs: Booking_Signin_WaitlistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please sign in to join the waitlist.`)
};

const es_booking_signin_waitlist = /** @type {(inputs: Booking_Signin_WaitlistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor inicia sesión para unirte a la lista de espera.`)
};

const fr_booking_signin_waitlist = /** @type {(inputs: Booking_Signin_WaitlistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez vous connecter pour rejoindre la liste d'attente.`)
};

const de_booking_signin_waitlist = /** @type {(inputs: Booking_Signin_WaitlistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte melde dich an, um der Warteliste beizutreten.`)
};

const id_booking_signin_waitlist = /** @type {(inputs: Booking_Signin_WaitlistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silakan masuk untuk bergabung dengan daftar tunggu.`)
};

/** @type {(inputs: Booking_Signin_WaitlistInputs) => LocalizedString} */
const ja_booking_signin_waitlist = en_booking_signin_waitlist;

/** @type {(inputs: Booking_Signin_WaitlistInputs) => LocalizedString} */
const zh_booking_signin_waitlist = en_booking_signin_waitlist;

/** @type {(inputs: Booking_Signin_WaitlistInputs) => LocalizedString} */
const ar_booking_signin_waitlist = en_booking_signin_waitlist;

/** @type {(inputs: Booking_Signin_WaitlistInputs) => LocalizedString} */
const it_booking_signin_waitlist = en_booking_signin_waitlist;

/** @type {(inputs: Booking_Signin_WaitlistInputs) => LocalizedString} */
const ru_booking_signin_waitlist = en_booking_signin_waitlist;

/** @type {(inputs: Booking_Signin_WaitlistInputs) => LocalizedString} */
const pt_booking_signin_waitlist = en_booking_signin_waitlist;

/** @type {(inputs: Booking_Signin_WaitlistInputs) => LocalizedString} */
const ko_booking_signin_waitlist = en_booking_signin_waitlist;

/**
* | output |
* | --- |
* | "Please sign in to join the waitlist." |
*
* @param {Booking_Signin_WaitlistInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const booking_signin_waitlist = /** @type {((inputs?: Booking_Signin_WaitlistInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Signin_WaitlistInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_booking_signin_waitlist(inputs)
	if (locale === "es") return es_booking_signin_waitlist(inputs)
	if (locale === "fr") return fr_booking_signin_waitlist(inputs)
	if (locale === "de") return de_booking_signin_waitlist(inputs)
	if (locale === "ja") return ja_booking_signin_waitlist(inputs)
	if (locale === "zh") return zh_booking_signin_waitlist(inputs)
	if (locale === "ar") return ar_booking_signin_waitlist(inputs)
	if (locale === "id") return id_booking_signin_waitlist(inputs)
	if (locale === "it") return it_booking_signin_waitlist(inputs)
	if (locale === "ru") return ru_booking_signin_waitlist(inputs)
	if (locale === "pt") return pt_booking_signin_waitlist(inputs)
	return ko_booking_signin_waitlist(inputs)
});